import { z } from 'zod/v3';

export const AuditorGalleryItemSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  isActive: z.boolean(),
});
export type AuditorGalleryItem = z.infer<typeof AuditorGalleryItemSchema>;

export const AuditorSysDescTemplateSchema = z.object({
  id: z.string(),
  auditorId: z.string(),
  version: z.string().nullable(),
  filename: z.string(),
  templateSlug: z.string(),
  isDefault: z.boolean(),
});
export type AuditorSysDescTemplate = z.infer<typeof AuditorSysDescTemplateSchema>;
